var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ns-toast_container",
      attrs: {
        opened: _vm.opened,
        theme: _vm.theme,
        type: _vm.type,
        duration: _vm.duration,
        icon: _vm.icon,
        "no-icon": _vm.noIcon,
        "show-close-icon": _vm.showCloseIcon
      }
    },
    [
      _c("div", { staticClass: "toast__scrim", on: { click: _vm.hide } }),
      _vm._v(" "),
      _c("section", { staticClass: "toast" }, [
        !_vm.usesCustomSlot
          ? _c("div", { staticClass: "responsive-container" }, [
              _c(
                "div",
                { staticClass: "responsive-container__inner-container" },
                [
                  _c(
                    "div",
                    { staticClass: "toast__content toast__content--left" },
                    [
                      _c("iron-icon", {
                        staticClass: "toast__icon--status",
                        attrs: { icon: _vm.iconInUse }
                      }),
                      _vm._v(" "),
                      _vm._t("toast-content-left")
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "toast__cta-section toast__content toast__content--right",
                      attrs: { id: "ctaWrapper", "action-type": "login" }
                    },
                    [_vm._t("cta")],
                    2
                  ),
                  _vm._v(" "),
                  _c("iron-icon", {
                    staticClass: "toast__icon--close",
                    attrs: { icon: "nuskin:icon-close" },
                    on: { click: _vm.hide }
                  })
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.usesCustomSlot
          ? _c("div", { staticClass: "custom" }, [_vm._t("custom")], 2)
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }